<template>
  <div class="faq-menu">
    <h3 class="faq-title">
      <span class="line"></span>
      <span class="text">FAQ</span>
      <span class="line"></span>
    </h3>

    <ul class="faq-list clearfix">
      <li class="list-item">
        <router-link class="link-item" to="/faq/faqNew">
          <i class="icon icon-phones"></i>
          <span class="text">新手教程</span>
        </router-link>
      </li>

      <li class="list-item">
        <router-link class="link-item" to="/faq/pluginFaq">
          <i class="icon icon-puzzle"></i>
          <span class="text">插件FAQ</span>
        </router-link>
      </li>

      <li class="list-item">
        <router-link class="link-item" to="/faq/backstage">
          <i class="icon icon-pc"></i>
          <span class="text">后台FAQ</span>
        </router-link>
      </li>

      <li class="list-item">
        <router-link class="link-item" to="/faq/income">
          <i class="icon icon-money"></i>
          <span class="text">收入FAQ</span>
        </router-link>
      </li>
    </ul>

    <h3 class="faq-title">
      <span class="line"></span>
      <span class="text">开发QQ群</span>
      <span class="line"></span>
    </h3>

    <p class="qq-group">QQ1群:546241346</p>
    <!--<p class="qq-group">QQ2群:549966296</p>-->

  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    name: 'faqLeft'
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "faqLeft.styl";
</style>



// WEBPACK FOOTER //
// src/components/faqLeft/faqLeft.vue